module.exports = __webpack_public_path__ + "assets/SS_classic_ball.f5c3db38.svg";